export const TOOLTIP_STORAGE_KEY = 'gig_page.packages_table.recurring_education';
